import Api from "@/api"
import type { VtsLog } from "@/models"
import { Temporal } from "@/Temporal"
import { defineStore } from "pinia"
import { ref, toRef } from "vue"
import { useEditingVtsLog } from "./useEditingVtsLog"
import { useVtsLogSearch } from "./vts-searching/useVtsLogSearch"
import { createCoreDataRefreshRef } from "@/stores/coreDataStore"

export const useVtsLogStore = defineStore("vts-logs", () => {
	const vtsLogSearch = useVtsLogSearch()
	const editingLog = useEditingVtsLog()
	const creationFormKey = ref(0)

	function resetCreationForm(){
		creationFormKey.value++
	}

	async function createVtsLog(log: VtsLog): Promise<void> {
		await Api.vts.create(log)
		await createCoreDataRefreshRef().queryData()
		void vtsLogSearch.refreshResults()
	}

	async function updateVtsLog(log: VtsLog): Promise<void> {
		await Api.vts.update(log)
		await createCoreDataRefreshRef().queryData()
		editingLog.closeLogPopup()
		void vtsLogSearch.refreshResults()
	}

	async function exportVtsLog(): Promise<void> {
		const blob = await Api.vts.export(vtsLogSearch.requestOptions)

		const downloadUrl = window.URL.createObjectURL(blob)
		const link = document.createElement("a")
		link.href = downloadUrl
		link.download = `VTS_Log_Export_${Temporal.Now.instant().toUTCDateTimeString().replaceAll(" ", "_")}`

		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
		window.URL.revokeObjectURL(downloadUrl)
	}

	return {
		...vtsLogSearch,
		...editingLog,
		creationFormKey,

		vtsLogsRef: toRef(() => vtsLogSearch.vtsLogsRef),

		resetCreationForm,
		createVtsLog,
		updateVtsLog,
		exportVtsLog,
	}
})
